window.ByrnaGA4 = (function () {

  function trunc(val, max) {
    return val ? String(val).substring(0, max) : '';
  }

  function fire(eventName, params) {
    if (typeof gtag !== 'function') return;
    gtag('event', eventName, params);
  }

  function featureBase(featureName, issueNumber, extras) {
    var r = new URLSearchParams(window.location.search);
    var base = {
      feature_name: featureName,
      issue_number: issueNumber,
      reason:     trunc(r.get('reason')     || '', 100),
      experience: trunc(r.get('experience') || '', 100),
      angle:      trunc(r.get('angle')      || '', 100)
    };
    return Object.assign({}, base, extras || {});
  }

  return {

    featureView: function (featureName, issueNumber, extras) {
      fire('feature_view', featureBase(featureName, issueNumber, extras));
    },

    featureClick: function (featureName, issueNumber, extras) {
      fire('feature_click', featureBase(featureName, issueNumber, extras));
    },

    featureComplete: function (featureName, issueNumber, extras) {
      fire('feature_complete', featureBase(featureName, issueNumber, extras));
    },

    setQuizUserProps: function (reason, experience, angle, productResult) {
      if (typeof gtag !== 'function') return;
      if (!reason && !experience && !angle) return;
      gtag('set', 'user_properties', {
        quiz_q1:     trunc(reason,        36),
        quiz_q2:     trunc(experience,    36),
        quiz_q3:     trunc(angle,         36),
        quiz_result: trunc(productResult, 36)
      });
    },

    viewItem: function (currency, value, items) {
      fire('view_item', { currency: currency, value: value, items: items });
    },

    viewItemList: function (listId, listName, items) {
      fire('view_item_list', {
        item_list_id:   listId,
        item_list_name: listName,
        items:          items
      });
    },

    selectItem: function (listId, listName, items) {
      fire('select_item', {
        item_list_id:   listId,
        item_list_name: listName,
        items:          items
      });
    },

    addToCart: function (currency, value, items) {
      fire('add_to_cart', { currency: currency, value: value, items: items });
    },

    trunc: trunc

  };

})();
